/**
 * useBackButton Hook
 * Handles back button navigation for web browsers and Android WebView
 * 
 * Behavior:
 * - On dashboard (/app): Send message to minimize app (on mobile) or go to previous browser page
 * - On other pages: Navigate back in React Router history
 */

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useBackButton() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // This hook doesn't interfere with normal browser back/forward
    // React Router handles that automatically
    
    // We only need to handle the special case when we want to exit/minimize the app
    // This is triggered by the native app's back button handler which calls goBack()
    // on the WebView, which triggers normal browser history navigation
    
    // No action needed here - browser back button works automatically with React Router
  }, [location.pathname, navigate]);
}
